<template>
  <div class="page_box">
    <div class="title_content">{{ title }}</div>
    <div class="msg_content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, toRefs } from 'vue';
const props = defineProps({
  title: {
    type: String,
    default: null,
  },
});

const { title } = toRefs(props);
</script>

<style lang="scss" scoped>
.page_box {
  width: 356px;
  height: 310px;
  background-size: 100% 100%;
  background-image: url(@/assets/images/public/pageBg.png);
  box-sizing: border-box;
  padding: 14px 0px 0px;
  .title_content {
    width: 336px;
    height: 40px;
    text-indent: 63px;
    color: #fafeff;
    text-shadow: 0px 1.185px 22.519px #18b1fe, 0px 1.185px 22.519px #18b1fe;
    font-family: 'MiSansS';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
  }

  .msg_content {
    position: absolute;
    width: 318px;
    height: 230px;
  }
}
</style>
